import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { Box, Button, Card, CardContent, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography } from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { logout } from '../../store/slices/AuthSlice';
import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Logout } from '../../connections/auth/AuthConnection';
import { CambiarContrasena } from '../../connections/admin/UsuarioConnection';

export const FirstLoginPage = () => {

    const dispatch = useDispatch();

    const [open, setOpen] = useState( false );

    const [loading, setLoading] = useState( false );
    const [loadingInicio, setLoadingInicio] = useState( false );

    const [viewContrasena, setViewContrasena] = useState( false );
    const [viewConfirmarContrasena, setViewConfirmarContrasena] = useState( false );

    const [contrasena, setContrasena] = useState( '' );
    const [confirmarContrasena, setConfirmarContrasena] = useState( '' );

    const handleChangePassword = async ( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {

        e.preventDefault();

        if ( !contrasena ) {
            dispatch( openSnackbar({ message: 'Debe escribir una contraseña', variant: 'warning' }));
            return;
        }
        else if ( !confirmarContrasena ) {
            dispatch( openSnackbar({ message: 'Debe escribir la confirmación de la contraseña', variant: 'warning' }));
            return;
        }
        else if ( contrasena !== confirmarContrasena ) {
            dispatch( openSnackbar({ message: 'Las contraseñas no coinciden', variant: 'warning' }));
            return;
        }
        else {

            setLoading( true );

            await CambiarContrasena({ contrasena }).then( resp => {

                setTimeout(() => {

                    const { success, message } = resp;

                    if ( success ) {

                        setLoading( false );
                        setOpen( true );

                        setContrasena( '' );
                        setConfirmarContrasena( '' );

                        dispatch( openSnackbar({ message: message, variant: 'success' }));

                    }
                    else {

                        dispatch( openSnackbar({ message: message, variant: 'error' }));
                        setLoading( false );

                    }

                }, 400);

            });

        }

    }

    const IniciarSesion = async () => {

        setLoadingInicio( true );

        await Logout().then( resp => {

            const { success, message } = resp;

            if ( success ) {

                setTimeout(() => {

                    window.localStorage.clear();

                    dispatch( logout() );
                    setLoadingInicio( false );

                }, 700);

            }
            else {

                setTimeout(() => {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingInicio( false );

                }, 400);

            }

        });

    }

    return (
        <>

            <Container maxWidth="xs">

                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    sx={{ minHeight: { xs: '100vh', md: '90vh' } }}
                >

                    <Grid size={{ xs: 12, md: 12 }}>

                        <Card sx={{ textAlign: 'center' }}>

                            <Box height={ 15 } bgcolor='#0A192D'></Box>

                            <CardContent sx={{ p: 3 }}>

                                <Typography variant="h3" textAlign={ 'center' }>

                                    <img style={{ height: 85 }}
                                        src={ process.env.PUBLIC_URL + '/assets/logo-simple.png' }
                                        alt='logo_saji'
                                    />

                                </Typography>

                                <Box>

                                    <Typography variant="h5" mt={ 1 } textAlign={ 'center' }>
                                        Cambiar contraseña
                                    </Typography>

                                    <Typography variant="subtitle1" color='secondary' fontSize={ 14 } mt={ 3 }>
                                        Para mayor seguridad de tu cuenta o si es la primera vez que iniciás sesión, necesitamos que cambies tu contraseña.
                                    </Typography>

                                    <form>

                                        <Grid container spacing={ 3 } mt={ 5 }>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink>Contraseña</InputLabel>
                                                    <OutlinedInput
                                                        notched
                                                        label="Contraseña"
                                                        name="contrasena"
                                                        placeholder='Escribe la nueva contraseña'
                                                        type={ viewContrasena ? 'text' : 'password' }
                                                        value={ contrasena }
                                                        onChange={ (e) => setContrasena( e.target.value ) }
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={ () => setViewContrasena( (prev) => !prev ) } edge="end" >
                                                                    {
                                                                        viewContrasena
                                                                        ?
                                                                            <VisibilityOffIcon />
                                                                        :
                                                                            <VisibilityIcon />
                                                                    }
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} mt={ 2 }>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink>Confirmar contraseña</InputLabel>
                                                    <OutlinedInput
                                                        notched
                                                        label="Confirmar contraseña"
                                                        name="contrasenaConfirm"
                                                        placeholder='Confirmación la nueva contraseña'
                                                        type={ viewConfirmarContrasena ? 'text' : 'password' }
                                                        value={ confirmarContrasena }
                                                        onChange={ (e) => setConfirmarContrasena( e.target.value ) }
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={ () => setViewConfirmarContrasena( (prev) => !prev ) } edge="end" >
                                                                    {
                                                                        viewConfirmarContrasena
                                                                        ?
                                                                        <VisibilityOffIcon />
                                                                        :
                                                                        <VisibilityIcon />
                                                                    }
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                </FormControl>

                                            </Grid>

                                        </Grid>

                                        <Button
                                            fullWidth
                                            type="submit"
                                            variant="contained"
                                            onClick={ handleChangePassword }
                                            sx={{ mt: 4, mb: 2 }}
                                            loading={ loading }
                                        >
                                            Cambiar contraseña
                                        </Button>

                                    </form>

                                </Box>

                            </CardContent>

                        </Card>

                    </Grid>

                </Grid>

            </Container>

            <Dialog open={ open } onClose={ () => {} } >

                <DialogTitle>
                    Iniciar sesión
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText sx={{ color: 'rgba(0, 0, 0, 0.8)' }}>
                        Para que los cambios surtan efecto es necesario volver a iniciar sesión.
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button variant="contained" color="primary" loading={ loadingInicio } onClick={ IniciarSesion }>
                        Aceptar
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    )
}